import { isJSXElement } from "@utils/common";
import React, { FC } from "react";

interface CaseStudyArray {
    id: number;
    bannerimg: string;
    title: string;
    link: string;
    linkRedirectText?: string;
    description: string;
}

interface CaseStudyType {
    related: CaseStudyArray[];
    sectionTitle?: string | JSX.Element;
    sectionDescription?: any;
}

/**
 * @deprecated Don't use this component. Instead use BlogOrCaseStudy Component
 */
const RelatedCaseStudies: FC<CaseStudyType> = ({ related, sectionTitle = "CASE STUDY", sectionDescription }) => {
    return (
        <section className=" max-w-6xl mx-auto">
            <div className="max-w-4xl mx-auto text-center">
                {sectionTitle && (isJSXElement(sectionTitle) ? sectionTitle : <h2 className="mt-12 text-4xl text-center">{sectionTitle}</h2>)}
                {sectionDescription && <p className=" text-lg justify-center text-center font-light  text-gray-500  mt-2 mb-10">{sectionDescription}</p>}
            </div>

            <div className="flex flex-wrap items-center justify-center gap-7 px-3">
                {related.map((x) => {
                    return <CaseStudy key={x.id} {...x} />;
                })}
            </div>
        </section>
    );
};

export default RelatedCaseStudies;
/**
 * @deprecated Don't use this component. Instead use BlogOrCaseStudy Component
 */
const CaseStudy: FC<Omit<CaseStudyArray, "id">> = ({ bannerimg, title, link, linkRedirectText = "Read Now", description }) => {
    return (
        <article className="related-work ">
            <img src={bannerimg} alt={title} className="rounded-t-2xl" />
            <div className="p-5">
                <h4 className="related-work-header m-0">{title} </h4>
                <p className="related-work-content pt-5">{description}</p>
                <div>
                    <a href={link} target="_blank" rel="noreferrer" className="related-work-btn flex gap-2 items-center justify-start  cursor-pointer my-4 ">
                        <p>{linkRedirectText}</p>
                        <img src="https://assets.gallabox.com/gb-home/case-study/Arrow.png" alt="right arrow" />
                    </a>
                </div>
            </div>
        </article>
    );
};
